import { allergyAPI } from '../api/allergy';
import { actionWrapper } from './actionWrapper';

export const SET_ALLERGIES = 'SET_ALLERGIES';

export const getAllergies = () => actionWrapper(async () => {
  const allergiesData = await allergyAPI.getAllergies();
  return {
    type: SET_ALLERGIES,
    payload: allergiesData,
  };
});